
export enum ActionType {
    FETCH_TODO = 'FETCH_TODO',
    ADD_TODO = 'ADD_TODO',
    EDIT_TODO = 'EDIT_TODO',
    DELETE_TODO = 'DELETE_TODO',
    COMPLETED_TODO = 'COMPLETED_TODO',
    UPDATE_TODO = 'UPDATE_TODO',
    DELETE_SELECTED = 'DELETE_SELECTED'
}